import { render, staticRenderFns } from "./EmarticonCard.vue?vue&type=template&id=9e50d506&scoped=true"
import script from "./EmarticonCard.vue?vue&type=script&lang=js"
export * from "./EmarticonCard.vue?vue&type=script&lang=js"
import style0 from "./EmarticonCard.vue?vue&type=style&index=0&id=9e50d506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e50d506",
  null
  
)

export default component.exports